import React from 'react';
import { createPortal } from 'react-dom';

const LowerProductSpecific = ({ content }) => {
  if (!content || content.includes('ff-bv-curations-wrapper')) {
    return null;
  }

  return createPortal(
    <div className="pdp-content-area__upper-wrapper">
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </div>,
    document.getElementById('LowerProductSpecificContent')
  );
};

export default LowerProductSpecific;
